<script>
import { services } from '@src/utils/common-services'
import { appConfig } from '@src/app.config'

export default {
  page: {
    title: 'Staff Managment',
    meta: [{ name: 'description', content: `Staff ${appConfig.title}` }],
  },

  data() {
    return {
      createStaffView: false,
      listStaffView: true,
      id: null,
      windowWidths: window.screen.width,
      minimizeFooter: false,
      preloader: false,
      createStaffMenu: false,
      deleteStaffMenu: false,
      editStaffMenu: false,
      classToggle: false,
      menuToggle: false,
    }
  },

  watch: {
    classToggle(val, oldVal) {
      if (val !== oldVal) {
        this.scrollToTop()
      }
    },
    menuToggle(val, oldVal) {
      if (val !== oldVal) {
        // console.log(this.menuToggle)
        //  this.setMenubar({ newVal: true })
        this.$root.$emit('open', this.menuToggle)
      }
    },
  },

  beforeMount() {
    this.img = null // this.currentUser.avatar
    var check = this.$store.getters['jv/get']('menu_list')
    var id = Object.keys(check)

    this.actions = this.getActions(check, id)
    if (this.actions !== undefined)
      if (this.actions.indexOf('view') === -1) {
        this.listStaffView = false
        this.$router.push({ name: '404' })
      } else {
        this.listStaffView = true
        if (this.actions.indexOf('create') !== -1) this.createStaffMenu = true
        if (this.actions.indexOf('edit') !== -1) this.editStaffMenu = true
        if (this.actions.indexOf('delete') !== -1) this.deleteStaffMenu = true
      }
    else {
      this.listStaffView = false
      this.$router.push({ name: '404' })
    }
  },
  beforeDestroy() {
    //  this.$root.$off('changeMenu')
    this.$off('view')
    this.$off('create')
    var doc = this.$refs.staff
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    getActions(check, id) {
      return services.searchActions(
        'Staff Management',
        check[id]._jv.attrs.config
      )
    },
    viewStaff(data) {
      this.listStaffView = data
      this.createStaffView = false
    },
    createStaff(data) {
      this.id = null
      this.listStaffView = false
      this.createStaffView = data
    },
    editStaff(id) {
      this.id = id

      this.listStaffView = false
      this.createStaffView = true
    },

    scrollToTop() {
      window.scrollTo(0, 0)
    },

    imageData(data) {
      this.image = data
    },
  },
}
</script>

<template>
  <div ref="staff">
    <StaffBaseStaffManagementCreate
      v-if="createStaffView"
      :id="id"
      @view="viewStaff"
    />
    <StaffBaseStaffManagementList
      v-if="listStaffView"
      :delete-menu="deleteStaffMenu"
      :edit-menu="editStaffMenu"
      :create-menu="createStaffMenu"
      @create="createStaff"
      @edit="editStaff"
    />
    <footer id="footer" :class="$style.footerWraper">
      <div
        :class="
          minimizeFooter
            ? [$style.responsiveFooter, $style.mimimize]
            : [$style.responsiveFooter]
        "
      >
        <div class="position-relative">
          <a
            :class="$style.footerMinimize"
            class="position-absolute"
            @click="minimizeFooter = !minimizeFooter"
            ><BIcon icon="grip-vertical"></BIcon
          ></a>
          <b-container fluid>
            <b-row>
              <b-col cols="4" sm="4">
                <button
                  :class="[$style.footerMenu, $style.menu]"
                  @click="menuToggle = !menuToggle"
                  ><BIcon class="" icon="grid"></BIcon>
                  <span :class="$style.footerMenuTxt">Menu</span>
                </button>
              </b-col>
              <b-col cols="4" sm="4">
                <button
                  :class="[$style.footerMenu, $style.dashboard]"
                  @click="$router.push({ name: 'dashboard' })"
                >
                  <BIcon icon="grid1x2"></BIcon>
                  <span :class="$style.footerMenuTxt">Dashboard</span>
                </button>
              </b-col>
              <b-col cols="4" sm="4">
                <button
                  :class="[$style.footerMenu, $style.settings, $style.selected]"
                  @click="classToggle = !classToggle"
                >
                  <BIcon class="" icon="person-plus"></BIcon>
                  <span :class="$style.footerMenuTxt">Invite Staff</span>
                </button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <div class="clear"></div>
    </footer>
  </div>
</template>
<style lang="scss" module>
@import '@design';
</style>
